import React, { useEffect, useState } from "react";
import { profile } from "../data/profile";
import "../App.css";

function extractImageFromDescription(description) {
  const div = document.createElement("div");
  div.innerHTML = description;
  const img = div.querySelector("img");
  return img ? img.src : null;
}

function Blogs() {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const feedUrl = encodeURIComponent(profile.contact.mediumFeed);
    fetch(`https://api.rss2json.com/v1/api.json?rss_url=${feedUrl}`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.items) {
          setError("Unable to load blog posts right now.");
          return;
        }
        const blogPosts = data.items.map((item) => ({
          title: item.title,
          link: item.link,
          pubDate: item.pubDate,
          thumbnail: extractImageFromDescription(item.description),
          description: item.description,
        }));
        setPosts(blogPosts);
      })
      .catch(() => setError("Unable to load blog posts right now."));
  }, []);

  return (
    <div className="blog-page">
      <div className="container site-section-inner pb-5">
        <header className="section-head">
          {/* <p className="section-eyebrow">Writing</p> */}
          <h1 className="section-title">My Blogs</h1>
          {/* <p className="section-lead">Articles from Medium on engineering, AI, and building software.</p> */}
        </header>

        {error ? <p className="text-muted">{error}</p> : null}

        <div className="projects-grid">
          {posts.map((post) => (
            <article className="project-item" key={post.link}>
              {post.thumbnail ? (
                <div className="project-item-media">
                  <img src={post.thumbnail} alt="" />
                </div>
              ) : (
                <div className="project-item-media project-item-media--empty" aria-hidden />
              )}
              <div className="project-item-body">
                <h2 className="h5 mb-2">{post.title}</h2>
                <p className="small text-muted mb-2">{post.pubDate.substring(0, 10)}</p>
                <p className="mb-3">
                  {post.description.replace(/<[^>]+>/g, "").substring(0, 180)}...
                </p>
                <a href={post.link} className="btn btn-dark align-self-start" target="_blank" rel="noreferrer">
                  Read More
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Blogs;
